// Pure client-side filtering + counting for the Club Radar (R2/R7). Kept in its
// own module (no service/axios import) so it is trivially unit-testable and the
// hook simply re-exports it. Watchlists are small, so status + scout-request
// filtering happens client-side, which lets the filter chips show live counts.
import { CLUB_STATUS_ORDER } from "../../constants/clubRadarChoices";

// An entry is "from a scout request" when its origin type is scout_request (R2),
// reading both the nested `origin.type` and a legacy flat `origin_type`.
export const isFromScoutRequest = (e) => (e?.origin?.type || e?.origin_type) === "scout_request";

export const computeStatusCounts = (entries = []) => {
  const counts = { all: entries.length, scout_requests: 0 };
  for (const s of CLUB_STATUS_ORDER) counts[s] = 0;
  for (const e of entries) {
    const s = e.status || "watching";
    if (counts[s] != null) counts[s] += 1;
    if (isFromScoutRequest(e)) counts.scout_requests += 1;
  }
  return counts;
};

export const filterVisible = (entries = [], filter = "all") => {
  if (filter === "all") return entries;
  if (filter === "scout_requests") return entries.filter(isFromScoutRequest);
  return entries.filter((e) => (e.status || "watching") === filter);
};
